<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold fd50SS">Our Services</h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <!-- start sec part -->
      <!-- start sec part -->
      <v-card class="elevation-0 bgpanel">
        <v-container>
          <div>
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12">
                <!-- observer wrapper for mobile heading -->
                <div ref="leftHeadingMobile" class="observer">
                  <h1
                    class="rainbow-text fontfamMon text-center font-weight-bold linespht display-1 anim-item fade-up delay-100"
                    style="font-size: clamp(20px, 4vw, 32px) !important"
                  >
                    We Have Created Professional Service For Our Customers.
                  </h1>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12" sm="4" lg="3">
                <div ref="imageCard2" class="observer">
                  <v-card
                    class="px-2 mx-2 pb-2 mb-2 d-none d-sm-block align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>

              <!-- RIGHT COLUMN -->
              <v-col cols="12" sm="8" lg="9">
                <v-card class="ma-2">
                  <div ref="paragraph" class="observer">
                    <p
                      class="mt-6 mt-lg-14 text-justify linespht1 black--text body-1 anim-item fade-left delay-300"
                    >
                      BUYUK is comprised of highly passionate and experienced individuals
                      dedicated towards delivering products and services of the highest
                      quality. Our Program Managers, Programmers, Creative Designers, and
                      Quality Analyzers, have extensive knowledge in developing mobile
                      apps, web applications and enterprise software.
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- observer wrapper for image card -->
              <v-col>
                <div ref="imageCard1" class="observer">
                  <v-card
                    class="px-12 mx-2 pb-2 mb-2 d-block d-sm-none align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
      <!-- end sec part -->
      <!-- start 4th section -->

      <v-container fluid class="pa-0">
        <div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-img class="white--text" src="@/assets/Certificates BG.png">
                <v-container fluid class="px-4 bgpanel">
                  <v-card class="black--text elevation-0 bgpanel" dark>
                    <v-container>
                      <div>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-card class="elevation-0">
                              <div class="waviy mx-lg-8 text-center mb-3">
                                <h1
                                  class="rainbow-text font-weight-bold linespht"
                                  style="font-size: clamp(20px, 4vw, 32px) !important"
                                >
                                  Our Services
                                </h1>
                              </div>
                              <p
                                class="linespht1 text-center d-block d-lg-none clrbluetext"
                              >
                                We have a dedicated team of experienced software experts
                                who can transform customer needs into quality software
                                products which are unique in themselves and cut down the
                                manual interventions and costs. Our focus is on developing
                                customized, client friendly software that automates
                                different areas of the business process.
                              </p>
                              <p
                                class="linespht1 text-center d-none d-lg-block clrbluetext"
                              >
                                We have a dedicated team of experienced software experts
                                who can transform customer needs into quality software
                                products which are unique in themselves and cut down the
                                manual interventions and costs. Our focus is on developing
                                customized, client friendly software that automates
                                different areas of the business process.
                              </p>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-card>
                </v-container>

                <v-container
                  class="services-block glass-effect py-0 my-0 my-md-2"
                  @mouseenter="stopAutoDisplay"
                  @mouseleave="startAutoDisplay"
                >
                  <div>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-card class="ma-2" elevation="2">
                          <!-- start slider -->

                          <v-container fluid class="py-0 px-0">
                            <v-row no-gutters class="d-flex align-stretch">
                              <!-- Left side: Tabs -->
                              <v-col cols="12" md="4" lg="3" class="d-none d-md-flex">
                                <div
                                  class="tabs-wrapper d-flex flex-column"
                                  style="height: 300px"
                                >
                                  <!-- top arrow -->
                                  <v-btn
                                    icon
                                    small
                                    class="scroll-btn top mb-2"
                                    :disabled="atTop"
                                    @click="scrollUp"
                                    :ripple="false"
                                  >
                                    <v-icon style="color: black">mdi-chevron-up</v-icon>
                                  </v-btn>

                                  <!-- scrollable tabs -->
                                  <div
                                    ref="tabsContainer"
                                    class="tabs-scroll flex-grow-1"
                                    @scroll="onScroll"
                                    style="
                                      max-height: 220px;
                                      overflow-y: auto;
                                      margin-top: 50px;
                                    "
                                  >
                                    <v-tabs
                                      v-model="tab"
                                      vertical
                                      background-color="white"
                                      class="rounded-xl"
                                    >
                                      <v-tab
                                        v-for="(item, i) in services"
                                        :key="i"
                                        :class="tab === i ? 'active-tab' : ''"
                                        :style="
                                          tab === i
                                            ? item.gradient
                                              ? {
                                                  backgroundImage: item.gradient,
                                                  color: '#fff',
                                                }
                                              : {
                                                  backgroundColor: item.color,
                                                  color: '#fff',
                                                }
                                            : {}
                                        "
                                        style="height: 55px"
                                      >
                                        <v-icon
                                          left
                                          :color="tab === i ? 'white' : 'primary'"
                                        >
                                          {{ item.icon }}
                                        </v-icon>
                                        {{ item.title }}
                                      </v-tab>
                                    </v-tabs>
                                  </div>

                                  <!-- bottom arrow -->
                                  <v-btn
                                    icon
                                    small
                                    class="scroll-btn bottom mt-2"
                                    :disabled="atBottom"
                                    @click="scrollDown"
                                    :ripple="false"
                                  >
                                    <v-icon style="color: black">mdi-chevron-down</v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                              <v-col cols="12" md="8" lg="9" class="d-flex">
                                <v-tabs-items
                                  v-model="tab"
                                  class="rounded-xl flex-grow-1 eager"
                                >
                                  <v-tab-item v-for="(item, i) in services" :key="i">
                                    <v-card
                                      flat
                                      class="py-13 px-8 rounded-xl fill-height"
                                      :style="
                                        tab === i
                                          ? item.gradient
                                            ? {
                                                backgroundImage: item.gradient,
                                                color: '#fff',
                                              }
                                            : {
                                                backgroundColor: item.color,
                                                color: '#fff',
                                              }
                                          : {}
                                      "
                                    >
                                      <v-row>
                                        <!-- Text Content -->
                                        <v-col
                                          cols="12"
                                          md="6"
                                          class="d-flex flex-column justify-center"
                                        >
                                          <h3
                                            class="font-weight-bold mb-4 animated-textbbn"
                                          >
                                            {{ item.title }}
                                          </h3>
                                          <!-- <p class="mb-4 text-justify">{{ item.description }}</p> -->
                                          <p class="mb-4 text-justify animated-textbbn">
                                            {{ item.description }}
                                          </p>

                                          <v-list dense>
                                            <v-list-item
                                              v-for="(client, j) in item.clients"
                                              :key="j"
                                              class="px-0"
                                            >
                                              <v-list-item-content>
                                                <v-list-item-title>
                                                  <v-btn
                                                    :href="client.link"
                                                    target="_blank"
                                                    color="white"
                                                    class="text-none"
                                                    small
                                                    rounded="pill"
                                                  >
                                                    {{ client.name }}
                                                  </v-btn>
                                                </v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>

                                        <!-- Images with Circular Rotation -->
                                        <v-col cols="12" md="6">
                                          <v-row dense justify="center">
                                            <!-- ✅ Center align all rows -->
                                            <v-col
                                              v-for="(img, k) in item.images"
                                              :key="k"
                                              cols="4"
                                              sm="3"
                                              md="5"
                                              xl="5"
                                              class="image-3d-wrapper d-flex justify-center"
                                            >
                                              <v-img
                                                :src="img"
                                                class="rounded-lg elevation-3 image-spin"
                                                height="100"
                                                width="100%"
                                                cover
                                              ></v-img>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-col>
                            </v-row>
                          </v-container>

                          <!-- end slider -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-img>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <!-- end 4th section -->

      <!-- start 3rd section -->
      <v-container fluid class="px-4 d-block d-lg-none">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1"
                        style="font-size: clamp(20px, 4vw, 32px) !important"
                      >
                        Why Buyuk is your Ideal Partner?
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <!-- start  4th section -->

      <v-container fluid class="pa-0 mb-0">
        <v-row no-gutters>
          <v-col cols="12">
            <!-- Background image wrapper -->
            <div class="bg-section d-flex align-center">
              <v-container>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="d-flex justify-center">
                    <v-card class="ma-2 pa-4" elevation="2" max-width="900">
                      <v-card-text class="text-center mx-auto">
                        <h3
                          class="linespht clrbluetext fd50 mb-6 white--text d-none d-lg-block shine-text"
                        >
                          Why Buyuk is your Ideal Partner?
                        </h3>
                        <p class="linespht body-1 white--text shine-text">
                          We have the ability to adapt to latest technology and we believe
                          in fostering win-win long lasting partnerships. Our commitment
                          ensures quality work delivered on time as quality begins on the
                          inside and then works its way out. We are responsible to our
                          commitment and accountable to the results as we believe our
                          responsibility builds a trust in partner minds.
                        </p>
                      </v-card-text>

                      <!-- start slider -->
                      <v-container fluid>
                        <v-row justify="center" align="center">
                          <!-- Marketing -->
                          <v-col cols="12" sm="4" class="text-center">
                            <div class="progress-circle">
                              <v-progress-circular
                                :rotate="-90"
                                :size="120"
                                :width="5"
                                :value="marketing"
                                class="yellclr"
                              >
                                {{ marketing }}
                              </v-progress-circular>
                              <div class="agenda mt-2">Marketing</div>
                            </div>
                          </v-col>

                          <!-- Web Design -->
                          <v-col cols="12" sm="4" class="text-center">
                            <div class="progress-circle">
                              <v-progress-circular
                                :rotate="-90"
                                :size="120"
                                :width="7"
                                :value="webdesign"
                                class="yellclr"
                              >
                                {{ webdesign }}
                              </v-progress-circular>
                              <div class="agenda mt-2">Web Design</div>
                            </div>
                          </v-col>

                          <!-- WordPress -->
                          <v-col cols="12" sm="4" class="text-center">
                            <div class="progress-circle">
                              <v-progress-circular
                                :rotate="-90"
                                :size="120"
                                :width="9"
                                :value="wordpress"
                                class="yellclr"
                              >
                                {{ wordpress }}
                              </v-progress-circular>
                              <div class="agenda mt-2">WordPress</div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                      <!-- end slider -->
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!-- end 4th section -->

      <!-- end 4th section -->

      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1"
                        style="font-size: clamp(20px, 4vw, 32px) !important"
                      >
                        Our Work Process
                      </h1>
                      <p class="text-justify body-1">
                        We create successful products that stands out from the crowd!
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="pa-4">
        <v-card class="black--text elevation-0" dark>
          <v-container fluid>
            <v-row class="text-center">
              <!-- Step 1 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-pencil</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Sketching</h3>
                    </div>
                    <div class="process-circle-num">01</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 2 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-tune</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Designing</h3>
                    </div>
                    <div class="process-circle-num">02</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 3 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-cog</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Reviewing</h3>
                    </div>
                    <div class="process-circle-num">03</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 4 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-send</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Launching</h3>
                    </div>
                    <div class="process-circle-num">04</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 3rd section -->

      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      marketing: 0,
      webdesign: 0,
      wordpress: 0,
      observer: null,
      parallaxHeight: 650,
      // If you prefer, you can keep the original "@/assets/homebg33.png" string,
      // but require() ensures the URL is resolved in styles as well.
      bgSrc: require("@/assets/bg-image1.jpg"),
      selected: 1,
      model: null,
      // start aug27
      tab: 0,
      atTop: true,
      atBottom: false,
      scrollStep: 80, // will be adjusted in mounted()
      autoInterval: null,
      services: [
        {
          title: "Sactin Interactive Panel",

          gradient: "linear-gradient(to right, #000046, #1cb5e0)",

          description:
            "It provides teachers with flexibility, reusability, and a variety of tools that make learning fun and intelligent. Similarly, for students, an interactive display in the classroom allow them to use technology productively , wisely and more effectively.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukInteractivePanel/panel1.jpg"),
            require("@/assets/BuyukInteractivePanel/panel2.jpg"),
            require("@/assets/BuyukInteractivePanel/panel3.jpg"),
          ],
        },
        {
          title: "Sactin GPS Tracking System",

          gradient: "linear-gradient(to right, #ee0979, #ff6a00)",
          description:
            "GPS tracking is the surveillance of location through use of the Global Positioning System (GPS ) to track the location of an entity or object remotely. The technology can pinpoint longitude, latitude, ground speed, and course direction of the target.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukGPStracking/gps1.jpg"),
            require("@/assets/BuyukGPStracking/gps2.jpg"),
            require("@/assets/BuyukGPStracking/gps3.jpg"),
          ],
        },
        {
          title: "Sactin Face Attentance System",

          gradient: " linear-gradient(to right, #8e0e00, #1f1c18)",
          description:
            "Sactin face attendance system works by verifying the person's face against the enrolled face to mark the person's daily attendance. All the individual need to do is stand in front of the camera and your face is verified instantly in milliseconds.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukAttentance/Attentance1.jpg"),
            require("@/assets/BuyukAttentance/Attentance2.jpg"),
            require("@/assets/BuyukAttentance/Attentance3.jpg"),
          ],
        },
        {
          title: "Sactin Real Time Tracking System",
          gradient: "linear-gradient(to right, #00bf8f, #001510)",
          description:
            "With so many people and things in motion, business and government leaders don't have time to manually track each movement. With location intelligence, they can create live maps and apps for monitoring.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukTracking/RealTimeTracking1.jpg"),
            require("@/assets/BuyukTracking/RealTimeTracking2.jpg"),
            require("@/assets/BuyukTracking/RealTimeTracking3.jpg"),
          ],
        },
        {
          title: "Sactin Library System",

          gradient: "linear-gradient(to right, #833ab4, #fd1d1d, #fcb045)",
          description:
            "Digital libraries are quickly becoming the norm at colleges and universities since they combine technology and information resources to allow remote access to educational content, breaking down the physical barriers.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/buyukLibrary/library1.jpg"),
            require("@/assets/buyukLibrary/library2.jpg"),
            require("@/assets/buyukLibrary/library3.jpg"),
          ],
        },
        {
          title: "Sactin ERP",

          gradient: "linear-gradient(to right, #52c234, #061700)",
          description:
            "The importance of an office administrator to an organization is substantial due to the duties that they are entrusted with; hence specialized training required , sactin ensure this with specialized ERP system.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukERP/ERP1.jpg"),
            require("@/assets/BuyukERP/ERP2.jpg"),
            require("@/assets/BuyukERP/ERP3.jpg"),
          ],
        },
        {
          title: "School Management System",

          gradient:
            " linear-gradient( 87.6deg,  rgba(241,16,48,1) 1.7%, rgba(242,171,33,1) 13.3%, rgba(226,242,33,1) 24.5%, rgba(12,207,22,1) 34.8%, rgba(75,205,200,1) 47.2%, rgba(8,39,211,1) 58.9%, rgba(150,101,229,1) 67.6%, rgba(80,6,198,1) 78.1%, rgba(246,98,248,1) 89.2%, rgba(248,98,181,1) 103.3%, rgba(228,129,144,1) 113.9% )",

          description:
            "Flawless Parent Teacher Communication. Improve your school image with our branded mobile app.",

          images: [
            require("@/assets/BuyukSchoolManagement/SMS1.jpg"),
            require("@/assets/BuyukSchoolManagement/SMS2.jpg"),
            require("@/assets/BuyukSchoolManagement/SMS3.jpg"),
          ],
        },
        {
          title: "Web Designing",
          gradient: "linear-gradient(to right, #000046, #1cb5e0)",

          description:
            "Whether you need to redesign your existing website or design one from scratch, we have got all the skills to make it happen for you.",

          images: [
            require("@/assets/BuyukWebdesign/webd1.jpg"),
            require("@/assets/BuyukWebdesign/webd2.jpg"),
            require("@/assets/BuyukWebdesign/webd3.jpg"),
          ],
        },
        {
          title: "Premium Support",

          gradient:
            "  linear-gradient(90deg, rgba(42, 0, 27, 1.000) 0.000%, rgba(120, 19, 12, 1.000) 16.667%, rgba(206, 72, 14, 1.000) 33.333%, rgba(255, 141, 34, 1.000) 50.000%, rgba(255, 213, 67, 1.000) 66.667%, rgba(255, 255, 105, 1.000) 83.333%, rgba(255, 255, 141, 1.000) 100.000%) ",
          description:
            "Our Beliefs and Strengths are - Teamwork. Commitment. Professional Delivery. Our vastly experienced team are ready to provide tailor-made solutions to match any type of customer requirement.",

          images: [
            require("@/assets/BuyukPremiumSupport/premiums1.jpg"),
            require("@/assets/BuyukPremiumSupport/premiums2.jpg"),
            require("@/assets/BuyukPremiumSupport/premiums3.jpg"),
          ],
        },
        {
          title: "Mobile App Development",

          gradient:
            "  conic-gradient(from 105deg, rgba(255, 191, 171, 1.000) 0.000deg, rgba(255, 191, 171, 1.000) 9.730deg, rgba(254, 173, 169, 1.000) 9.730deg, rgba(254, 173, 169, 1.000) 19.459deg, rgba(237, 156, 167, 1.000) 19.459deg, rgba(237, 156, 167, 1.000) 29.189deg, rgba(220, 138, 165, 1.000) 29.189deg, rgba(220, 138, 165, 1.000) 38.919deg, rgba(204, 122, 164, 1.000) 38.919deg, rgba(204, 122, 164, 1.000) 48.649deg, rgba(189, 105, 162, 1.000) 48.649deg, rgba(189, 105, 162, 1.000) 58.378deg, rgba(173, 90, 160, 1.000) 58.378deg, rgba(173, 90, 160, 1.000) 68.108deg, rgba(159, 76, 158, 1.000) 68.108deg, rgba(159, 76, 158, 1.000) 77.838deg, rgba(145, 64, 156, 1.000) 77.838deg, rgba(145, 64, 156, 1.000) 87.568deg, rgba(132, 53, 154, 1.000) 87.568deg, rgba(132, 53, 154, 1.000) 97.297deg, rgba(120, 44, 152, 1.000) 97.297deg, rgba(120, 44, 152, 1.000) 107.027deg, rgba(108, 37, 151, 1.000) 107.027deg, rgba(108, 37, 151, 1.000) 116.757deg, rgba(98, 32, 149, 1.000) 116.757deg, rgba(98, 32, 149, 1.000) 126.486deg, rgba(88, 29, 147, 1.000) 126.486deg, rgba(88, 29, 147, 1.000) 136.216deg, rgba(80, 28, 145, 1.000) 136.216deg, rgba(80, 28, 145, 1.000) 145.946deg, rgba(72, 30, 143, 1.000) 145.946deg, rgba(72, 30, 143, 1.000) 155.676deg, rgba(66, 34, 141, 1.000) 155.676deg, rgba(66, 34, 141, 1.000) 165.405deg, rgba(61, 39, 139, 1.000) 165.405deg, rgba(61, 39, 139, 1.000) 175.135deg, rgba(57, 47, 137, 1.000) 175.135deg, rgba(57, 47, 137, 1.000) 184.865deg, rgba(54, 57, 135, 1.000) 184.865deg, rgba(54, 57, 135, 1.000) 194.595deg, rgba(53, 69, 133, 1.000) 194.595deg, rgba(53, 69, 133, 1.000) 204.324deg, rgba(53, 82, 131, 1.000) 204.324deg, rgba(53, 82, 131, 1.000) 214.054deg, rgba(54, 97, 129, 1.000) 214.054deg, rgba(54, 97, 129, 1.000) 223.784deg, rgba(56, 112, 127, 1.000) 223.784deg, rgba(56, 112, 127, 1.000) 233.514deg, rgba(59, 129, 124, 1.000) 233.514deg, rgba(59, 129, 124, 1.000) 243.243deg, rgba(64, 146, 122, 1.000) 243.243deg, rgba(64, 146, 122, 1.000) 252.973deg, rgba(70, 164, 120, 1.000) 252.973deg, rgba(70, 164, 120, 1.000) 262.703deg, rgba(77, 181, 118, 1.000) 262.703deg, rgba(77, 181, 118, 1.000) 272.432deg, rgba(85, 198, 116, 1.000) 272.432deg, rgba(85, 198, 116, 1.000) 282.162deg, rgba(94, 215, 114, 1.000) 282.162deg, rgba(94, 215, 114, 1.000) 291.892deg, rgba(104, 231, 112, 1.000) 291.892deg, rgba(104, 231, 112, 1.000) 301.622deg, rgba(116, 246, 110, 1.000) 301.622deg, rgba(116, 246, 110, 1.000) 311.351deg, rgba(128, 255, 108, 1.000) 311.351deg, rgba(128, 255, 108, 1.000) 321.081deg, rgba(140, 255, 105, 1.000) 321.081deg, rgba(140, 255, 105, 1.000) 330.811deg, rgba(154, 255, 103, 1.000) 330.811deg, rgba(154, 255, 103, 1.000) 340.541deg, rgba(168, 255, 101, 1.000) 340.541deg, rgba(168, 255, 101, 1.000) 350.270deg, rgba(183, 255, 99, 1.000) 350.270deg 360.000deg)",
          description:
            "we are here with you to turn your innovative ideas into attractive mobile applications.",

          images: [
            require("@/assets/BuyukMobileApp/mapp1.jpg"),
            require("@/assets/BuyukMobileApp/mapp2.jpg"),
            require("@/assets/BuyukMobileApp/mapp3.jpg"),
          ],
        },
        {
          title: "Customised Software",

          gradient:
            "  conic-gradient(from 180deg, rgba(0, 0, 0, 1.000) 0.000deg, rgba(0, 0, 0, 1.000) 10.909deg, rgba(0, 0, 0, 1.000) 21.818deg, rgba(2, 0, 0, 1.000) 32.727deg, rgba(27, 0, 0, 1.000) 43.636deg, rgba(52, 0, 0, 1.000) 54.545deg, rgba(78, 0, 0, 1.000) 65.455deg, rgba(102, 0, 0, 1.000) 76.364deg, rgba(124, 7, 0, 1.000) 87.273deg, rgba(143, 29, 0, 1.000) 98.182deg, rgba(159, 52, 7, 1.000) 109.091deg, rgba(169, 75, 29, 1.000) 120.000deg, rgba(175, 97, 52, 1.000) 130.909deg, rgba(176, 117, 75, 1.000) 141.818deg, rgba(172, 135, 97, 1.000) 152.727deg, rgba(162, 150, 117, 1.000) 163.636deg, rgba(148, 161, 135, 1.000) 174.545deg, rgba(130, 168, 149, 1.000) 185.455deg, rgba(109, 170, 160, 1.000) 196.364deg, rgba(85, 169, 166, 1.000) 207.273deg, rgba(60, 162, 169, 1.000) 218.182deg, rgba(34, 152, 166, 1.000) 229.091deg, rgba(10, 138, 160, 1.000) 240.000deg, rgba(0, 121, 149, 1.000) 250.909deg, rgba(0, 101, 134, 1.000) 261.818deg, rgba(0, 79, 117, 1.000) 272.727deg, rgba(0, 56, 96, 1.000) 283.636deg, rgba(0, 33, 74, 1.000) 294.545deg, rgba(0, 11, 52, 1.000) 305.455deg, rgba(0, 0, 29, 1.000) 316.364deg, rgba(0, 0, 7, 1.000) 327.273deg, rgba(0, 0, 0, 1.000) 338.182deg, rgba(0, 0, 0, 1.000) 349.091deg, rgba(0, 0, 0, 1.000) 360.000deg)",
          description:
            "If you have any questions regarding outsourcing your software please don't hesitate to contact us. We have a dedicated team of technologists who can understand all your needs and transform them into wonderful software product.",

          images: [
            require("@/assets/BuyukCSoftware/cs1.jpg"),
            require("@/assets/BuyukCSoftware/cs2.jpg"),
            require("@/assets/BuyukCSoftware/cs3.jpg"),
          ],
        },
        {
          title: "Web App Development",

          gradient:
            " linear-gradient( 111.5deg,  rgba(249,230,1,1) 9.9%, rgba(249,144,1,1) 19.4%, rgba(255,22,22,1) 29.2%, rgba(255,22,133,1) 37.7%, rgba(255,22,197,1) 47.7%, rgba(232,22,255,1) 53.9%, rgba(162,22,255,1) 60%, rgba(80,22,255,1) 68.8%, rgba(22,104,255,1) 74.2%, rgba(22,168,255,1) 77.6%, rgba(22,255,220,1) 86.7%, rgba(22,255,179,1) 92.5%, rgba(22,255,109,1) 97.1%, rgba(92,255,22,1) 103.5% )",
          description:
            "With our experience in marketing mass consumer products, we help you to build your dream product at the lowest cost and quick market release.",

          images: [
            require("@/assets/BuyukWebApp/webapp1.jpg"),
            require("@/assets/BuyukWebApp/webapp2.jpg"),
            require("@/assets/BuyukWebApp/webapp3.jpg"),
          ],
        },
      ],
      //  end aug27
    };
  },
  beforeDestroy() {
    this.stopAutoDisplay();
  },
  beforeDestroy() {
    clearInterval(this.autoInterval);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateParallaxHeight);
  },
  watch: {
    // Recalculate if your cards list changes
    Servicescards: {
      handler() {
        this.$nextTick(this.updateParallaxHeight);
      },
      deep: true,
    },
  },
  methods: {
    animateProgress() {
      this.animateValue("marketing", 78, 2000);
      this.animateValue("webdesign", 85, 2000);
      this.animateValue("wordpress", 93, 2000);
    },
    animateValue(field, end, duration) {
      let start = 0;
      let startTime = null;

      const animate = (time) => {
        if (!startTime) startTime = time;
        let progress = Math.min((time - startTime) / duration, 1);
        this[field] = Math.floor(progress * end);
        if (progress < 1) requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    },
    startAutoDisplay() {
      this.stopAutoDisplay(); // prevent duplicate intervals
      this.autoInterval = setInterval(() => {
        this.tab = (this.tab + 1) % this.services.length;

        this.$nextTick(() => {
          const tabs = this.$refs.tabsContainer;
          const active = tabs?.querySelector(".v-tab.active-tab");
          if (active && tabs) {
            tabs.scrollTop = active.offsetTop - tabs.offsetTop;
          }
        });
      }, 4000);
    },

    stopAutoDisplay() {
      if (this.autoInterval) {
        clearInterval(this.autoInterval);
        this.autoInterval = null;
      }
    },

    scrollUp() {
      this.$refs.tabsContainer.scrollBy({ top: -60, behavior: "smooth" });
    },
    scrollDown() {
      this.$refs.tabsContainer.scrollBy({ top: 60, behavior: "smooth" });
    },
    onScroll() {
      const el = this.$refs.tabsContainer;
      this.atTop = el.scrollTop === 0;
      this.atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
    },
    onScroll() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      this.atTop = c.scrollTop <= 0;
      this.atBottom = Math.ceil(c.scrollTop + c.clientHeight) >= c.scrollHeight;
    },
    scrollUp() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      c.scrollBy({ top: -this.scrollStep, left: 0, behavior: "smooth" });
    },
    scrollDown() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      c.scrollBy({ top: this.scrollStep, left: 0, behavior: "smooth" });
    },

    updateHeight() {
      const el = this.$refs.contentBlock;
      if (el) {
        this.parallaxHeight = el.offsetHeight + 60; // +60px buffer
      }
    },
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
    updateParallaxHeight() {
      // Only matters on desktop (where v-parallax is used)
      if (this.$vuetify.breakpoint.smAndDown) return;
      const el = this.$refs.contentDesktop;
      if (!el) return;
      const h = el.offsetHeight;
      // Add a small buffer so the parallax image covers edge-to-edge
      if (h && h > 0) this.parallaxHeight = Math.ceil(h + 32);
    },

    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    this.animateProgress();
    this.startAutoDisplay();
    this.$nextTick(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
      }, 100); // wait for Vuetify to try scrolling
    });
    // compute step based on first tab height if available
    this.$nextTick(() => {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      const container = this.$refs.tabsContainer;
      const firstTab = container && container.querySelector(".v-tab");
      if (firstTab) {
        this.scrollStep = Math.max(firstTab.offsetHeight, 60);
      } else {
        // fallback to proportional step
        this.scrollStep = Math.round(container.clientHeight * 0.6);
      }
      this.onScroll();
      // keep button state updated on resize
      window.addEventListener("resize", this.onScroll);
      this.$nextTick(this.updateParallaxHeight);
      window.addEventListener("resize", this.updateParallaxHeight, { passive: true });
      this.startAutoDisplay();
    });
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "rightHeadingDesktop",
      "paragraph",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}
.three-d-card {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.three-d-card:hover {
  transform: rotateY(15deg) rotateX(10deg) scale(1.05);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);

  background-image: radial-gradient(
    circle 1008px at -0.5% 50.2%,
    rgba(255, 85, 0, 1) 0%,
    rgba(255, 246, 73, 1) 50.4%,
    rgba(0, 233, 50, 1) 100.2%
  );
  color: white;
  padding: 40px 20px;
  border-radius: 9;
}

/* start aug27 */
.services-block {
  background: #fafafa;
}

.v-tab {
  font-weight: 600;
  text-transform: none;
  transition: 0.3s;
}

.glass-effect {
  border-radius: 15px;
  padding: 90px 0px 80px 0px;
  color: #0a0606;
  background-color: #ffffff;
  box-shadow: 2px 8px 16px 4px rgba(0, 0, 0, 0.08);
}

.tabs-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
  /* adjust height as needed */
  display: block;
}

/* the scroll area — native scrollbar visually hidden but still scrollable */
.tabs-scroll {
  height: 100%;
  overflow-y: auto;
  padding-top: 40px;
  /* gives space so top arrow doesn't overlap content */
  padding-bottom: 40px;
  /* same for bottom */
  -ms-overflow-style: none;
  /* IE/Edge */
  scrollbar-width: none;
  /* Firefox */
}

.tabs-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome/Safari */
}

/* overlay arrows centered horizontally */
.scroll-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  background: white;
}

/* small offset so arrows don't collide with the card border */
.scroll-btn.top {
  top: 6px;
}

.scroll-btn.bottom {
  bottom: -40px;
}

/* optional: slight fade overlays to hint that content continues */
.tabs-scroll::before,
.tabs-scroll::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 28px;
  pointer-events: none;
  z-index: 10;
}

.tabs-scroll::before {
  top: 40px;
}

.tabs-scroll::after {
  bottom: 40px;
}

/* disabled button appearance */
.v-btn[disabled] {
  opacity: 0.45;
  pointer-events: none;
}

.v-tabs:focus {
  outline: none !important;
}

/* end aug 27 */
.image-3d-wrapper {
  perspective: 1200px;
  padding: 12px;
  /* space between images */
}

.image-spin {
  animation: spinCircle 6s linear infinite;
  transform-style: preserve-3d;
  border-radius: 12px;
}

/* Circular rotation */
@keyframes spinCircle {
  0% {
    transform: rotateY(0deg) scale(1);
  }

  25% {
    transform: rotateY(90deg) scale(1.05);
  }

  50% {
    transform: rotateY(180deg) scale(1.1);
  }

  75% {
    transform: rotateY(270deg) scale(1.05);
  }

  100% {
    transform: rotateY(360deg) scale(1);
  }
}

.animated-textbbn {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 1s ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.parallax-wrapper {
  width: 100%;
}
.progress-circle {
  display: inline-block;
  margin: 20px;
}
.agenda {
  margin-top: 10px;
  font-weight: bold;
  font-size: 16px;
}
.bg-section {
  background: url("@/assets/newbgdd.jpg") center center / cover no-repeat;
  width: 100%;
  /* Height grows automatically based on content */
}
.yellclr {
  color: #e29803;
}
/* start */
.shine-text {
  background: linear-gradient(90deg, #ffffff 0%, #ffdd00 50%, #ffffff 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 4s linear infinite;
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}
/* stop */
</style>
